import React from 'react';
import { Checkbox, LABEL_PLACEMENT } from 'baseui/checkbox';
type PropsT = {
  title: string;
  setLabelMap: (labelMap: {
    [key: string]: boolean;
  }) => void;
  labelMap: {
    [key: string]: boolean;
  };
};
const getFilterOverrides = () => {
  return {
    Root: {
      style: ({
        $theme: {
          colors
        }
      }) => {
        return {
          color: colors.primaryA,
          backgroundColor: colors.secondary,
          width: '100%',
          border: `1px solid ${colors.borderOpaque}`,
          ':hover': {
            backgroundColor: colors.accent200
          },
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'flex-end',
          borderRadius: '2px',
          padding: '10px',
          marginRight: '10px'
        };
      }
    }
  };
};
const FilterItem = ({
  title,
  setLabelMap,
  labelMap
}: PropsT) => {
  return <Checkbox key={title} checked={labelMap[title]} onChange={e => {
    const updatedLabelMap = e.target.checked ? {
      ...labelMap,
      [title]: true
    } : {
      ...labelMap,
      [title]: false
    };
    setLabelMap(updatedLabelMap);
  }} labelPlacement={LABEL_PLACEMENT.right} overrides={getFilterOverrides()}>
      {title}
    </Checkbox>;
};
export default FilterItem;